import { FiChevronDown } from 'react-icons/fi'
import { cn } from '../../utils/cn'

export interface FilterOption {
  value: string
  label: string
}

interface Props {
  /** Drawn while nothing is chosen, and the option that clears the filter. */
  allLabel: string
  value: string
  options: FilterOption[]
  onChange: (value: string) => void
  className?: string
}

/**
 * A table filter drawn as a pill, to sit alongside the transactions date
 * range. It is a native `<select>` rather than a styled menu: the super admin
 * screens are the only place this appears, and the native control already
 * handles keyboard, touch and long option lists correctly.
 */
const FilterSelect = ({
  allLabel,
  value,
  options,
  onChange,
  className,
}: Props) => (
  <div className={cn('relative', className)}>
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={cn(
        'appearance-none cursor-pointer rounded-lg border-[1px] border-solid border-borderGray bg-white py-3 pl-3 pr-9 text-sm transition-colors hover:bg-mainBg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primaryBlue/40',
        value ? 'text-textBlack' : 'text-lightGray',
      )}
    >
      <option value=''>{allLabel}</option>
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          className='text-textBlack'
        >
          {option.label}
        </option>
      ))}
    </select>
    <FiChevronDown className='pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-base text-textBlack' />
  </div>
)

export default FilterSelect
